import styled, { css } from "styled-components";

const Label = styled.label`
  display: block;

  ${({ uiKitConfiguration }) => {
    return css`
      font-family: ${uiKitConfiguration && uiKitConfiguration.font_family};
    `;
  }};
`;

export default Label;
